class GiftCardCheckout extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (e)=>{
      e.preventDefault();
      if(document.querySelector('[data-gc-selector-ref]')) {
        const selectElement = document.querySelector('[data-gc-selector-ref]');
        const selectedOption = selectElement.options[selectElement.selectedIndex];
        const variantId = selectedOption.getAttribute('data-variant');
        window.location.href = `https://${window.Shopify.shop}/cart/clear?return_to=/cart/add?items[][id]=${variantId}%26items[][quantity]=1%26return_to=/checkout`
      }

    })
  }

  static get observedAttributes() {
    return ['data-q', 'data-v'];
  }

  connectedCallback(){
    let _q = document.querySelector('[data-quantity-el]').getAttribute('data-quantity') || null;
    let _v = document.querySelector('[data-variant-el]').getAttribute('data-current-id') || null;
    this.setAttribute('data-url', `${window.Shopify.shop}/cart/clear?return_to=/cart/add?items[][id]=${_v}%26items[][quantity]=${_q}%26return_to=/checkout`);
    this.setAttribute('data-q', _q);
    this.setAttribute('data-v', _v);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    let _q = this.getAttribute("data-q");
    let _v = this.getAttribute("data-v");
    this.setAttribute('data-url', `${window.Shopify.shop}/cart/clear?return_to=/cart/add?items[][id]=${_v}%26items[][quantity]=${_q}%26return_to=/checkout`);
  }

}

customElements.define('gift-card-checkout', GiftCardCheckout);

// bump